import { useMemo } from 'react';

import { OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS } from 'global/constants';
import { ActivityOutcomes } from '../activity-outcomes.constants';
import { BoxPanel } from 'approot/shared/styles/box-panel.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';
import { SettingsHr } from 'approot/activity-builder/settings/settings.style';
import QuestionTypesView from '../content-points/question-types-view';
import CerTypesView from '../content-points/cer-types-view';
import buildGroupsFromActivityOutcomes from './logic/build-performance-expectation-groups';
import sortPerformanceExpectationDimensions from 'approot/shared/outcomes/sort-performance-expectations-dimensions';

type PerformanceExpectationViewProps = {
  outcomes: ActivityOutcomes;
};

const PerformanceExpectationView = ({
  outcomes,
}: PerformanceExpectationViewProps) => {
  const peGroups = useMemo(
    () => buildGroupsFromActivityOutcomes(outcomes),
    [outcomes]
  );

  return peGroups.map((group, index) => {
    const peValues =
      group.outcomes[OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS] ?? [];
    const hasPe = peValues.length > 0;
    return (
      <BoxPanel key={index} $marginBottom={12}>
        {hasPe && (
          <Box $marginBottom={12}>
            <Heading16 as="h3" marginBottom={0}>
              Performance Expectation
            </Heading16>
            <Text $marginBottom={4}>{peValues[0].label}</Text>
            <Text>{peValues[0].description}</Text>
          </Box>
        )}

        <SettingsHr />

        {sortPerformanceExpectationDimensions(
          Object.keys(group.outcomes).filter(
            k => k !== OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS
          )
        ).map(key => {
          const values = group.outcomes[key] ?? [];
          const categoryLabel = values[0]?.category;
          if (values.length === 0) return null;
          return (
            <Box key={key} $marginTop={12}>
              <Heading16 as="h3" marginBottom={0}>
                {categoryLabel}
              </Heading16>
              {values.map(selected => (
                <Text key={selected.value}>
                  {selected.name ?? selected.label}
                </Text>
              ))}
            </Box>
          );
        })}

        {group.questionTypes.length > 0 && (
          <QuestionTypesView questionTypes={group.questionTypes} />
        )}
        {group.cerTypes.length > 0 && (
          <CerTypesView cerTypes={group.cerTypes} />
        )}
      </BoxPanel>
    );
  });
};

export default PerformanceExpectationView;
